// https://v3-migration.vuejs.org/breaking-changes/events-api
import { createNanoEvents } from 'nanoevents';

const emitter = createNanoEvents();

export default {
    $on: (...args) => emitter.on(...args),
    $once: (event, callback) => {
        const remove = emitter.on(event, (...args) => {
            callback(...args);
            remove();
        });
    },
    $off: (event) => {
        delete emitter.events[event];
    },
    $emit: (...args) => emitter.emit(...args),
};
